/* Productkaart v2 — maat-klik werkt prijs, oude prijs, kortingspill, voorraad en link bij (event-delegation; ook voor ajax-grids). Lichtgewicht. */
(function(){
  function splitMoney(mp){ var i = mp.lastIndexOf(','); return i >= 0 ? [mp.slice(0, i), mp.slice(i)] : [mp, '']; }
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('button[data-pc-size]'); if(!btn) return;
    var card = btn.closest('.pc'); if(!card) return;
    e.preventDefault(); e.stopPropagation();
    card.querySelectorAll('button[data-pc-size]').forEach(function(b){ b.classList.remove('is-active'); b.removeAttribute('aria-pressed'); });
    btn.classList.add('is-active'); btn.setAttribute('aria-pressed','true');
    if(btn.dataset.price){
      var p = splitMoney(btn.dataset.price);
      var mainEl = card.querySelector('[data-pc-price-main]'); if(mainEl) mainEl.innerHTML = p[0];
      var centsEl = card.querySelector('[data-pc-price-cents]'); if(centsEl) centsEl.textContent = p[1];
    }
    /* oude prijs en kortingspill volgen de gekozen maat */
    var was = card.querySelector('[data-pc-price-was]');
    if(was){ was.hidden = !btn.dataset.was; if(btn.dataset.was) was.innerHTML = '<span class="pc__sr">Was </span>' + btn.dataset.was; }
    var sale = card.querySelector('[data-pc-sale]');
    if(sale){ sale.textContent = btn.dataset.sale || ''; }
    var vanaf = card.querySelector('.pc__vanaf'); if(vanaf) vanaf.hidden = true;   /* bij een gekozen maat staat er een exacte prijs */
    var link = card.querySelector('.pc__link'); if(link && btn.dataset.url) link.setAttribute('href', btn.dataset.url);
    var badge = card.querySelector('.pc__badge');
    if(badge){
      var avail = btn.dataset.available === 'true';
      badge.classList.remove('pc__badge--low');
      badge.classList.toggle('pc__badge--out', !avail);
      var sl = (btn.dataset.scarceLabel || '').trim();
      badge.classList.toggle('pc__badge--schaars', avail && !!sl);
      var label = badge.querySelector('span:last-child');
      if(label) label.textContent = !avail ? 'Uitverkocht' : (sl || 'Op voorraad');
    }
  }, true);
})();

/* Prijzen op één lijn: de omschrijving (specificatie) van kaarten in dezelfde rij krijgt dezelfde hoogte. Alleen als een kaart in de rij
   twee regels nodig heeft, worden de andere kaarten in die rij even hoog; rijen met overal één regel blijven compact. */
(function(){
  var raf = 0, timer = 0;
  function align(){
    raf = 0;
    var list = [].slice.call(document.querySelectorAll('.pc__variant'));
    list.forEach(function(v){ v.style.minHeight = ''; });
    var rows = {};
    list.forEach(function(v){
      var card = v.closest('.pc'); if(!card || !card.offsetParent) return;
      var top = Math.round(card.getBoundingClientRect().top + window.pageYOffset);
      (rows[top] = rows[top] || []).push(v);
    });
    Object.keys(rows).forEach(function(k){
      var r = rows[k]; if(r.length < 2) return;
      var max = 0; r.forEach(function(v){ max = Math.max(max, v.getBoundingClientRect().height); });
      r.forEach(function(v){ v.style.minHeight = max + 'px'; });
    });
  }
  function req(){ if(!raf) raf = requestAnimationFrame(align); }
  function later(){ clearTimeout(timer); timer = setTimeout(req, 120); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', req); else req();
  window.addEventListener('load', req);
  window.addEventListener('resize', later);
  document.addEventListener('cro:grid-updated', req);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(req);
  if('MutationObserver' in window) new MutationObserver(function(ms){
    for(var i = 0; i < ms.length; i++){ var n = ms[i].addedNodes; for(var j = 0; j < n.length; j++){ if(n[j].nodeType === 1 && (n[j].matches('.pc-cell, .productgrid--item') || n[j].querySelector && n[j].querySelector('.pc'))){ later(); return; } } }
  }).observe(document.body, { childList: true, subtree: true });
})();
